import React from 'react';
import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const ColumnSectionHeader = ({ number, title, subtitle, subtitleTooltip, endAdornment }) => (
  <Box mb={2}>
    <Box display='flex' alignItems='flex-start' justifyContent='space-between' gap={1} mb={0.75}>
      <Box display='flex' alignItems='center' gap={1.25} minWidth={0}>
        <Box
          sx={{
            width: 26,
            height: 26,
            borderRadius: '50%',
            bgcolor: 'primary.main',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 700,
            flexShrink: 0,
          }}
        >
          {number}
        </Box>
        <Typography variant='subtitle1' fontWeight={700} lineHeight={1.3}>
          {title}
        </Typography>
      </Box>
      {endAdornment}
    </Box>
    {subtitle && (
      <Box display='flex' alignItems='flex-start' gap={0.75} sx={{ pl: '38px' }}>
        <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.5, flex: 1 }}>
          {subtitle}
        </Typography>
        {subtitleTooltip && (
          <Tooltip
            title={subtitleTooltip}
            arrow
            placement='top'
            slotProps={{
              tooltip: {
                sx: {
                  maxWidth: 340,
                  bgcolor: '#0f172a',
                  p: 1.5,
                },
              },
            }}
          >
            <IconButton size='small' aria-label='Sharing information' sx={{ mt: -0.25, color: 'text.secondary' }}>
              <InfoOutlinedIcon sx={{ fontSize: 16 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    )}
  </Box>
);

export default ColumnSectionHeader;
